// #region imports

// --- Angular
import { Component, Input } from '@angular/core';

// --- HS Code
import { ScoreModel, ResultsStatuses } from '../../../models';

// #endregion

@Component({
  selector: 'hs-results-chart',
  templateUrl: './results-chart.component.html',
  styleUrls: ['./results-chart.component.scss']
})
export class ResultsChartComponent {
  @Input() resultsStatus: ResultsStatuses = ResultsStatuses.surveyIncomplete;
  @Input() scores: ScoreModel[][] | null = null;
  @Input() imagesRootUrl: string = '';

  resultsStatuses = ResultsStatuses;
}
